export default function (instance) {
    return {
        getReservations(params = null){
            return instance.get('reservation', params)
        },
        getReservation(id){
            return instance.get('reservation/'+id)
        },
        getTrainer(id){
            return instance.get('trainer/'+id)
        },
        getSchedule(id){
            return instance.get('schedule/'+id)
        },
        postSchedule(id){
            return instance.postForm('schedule', {training: id})
        },
        deleteSchedule(id){
            return instance.delete('schedule/'+id)
        },
    }
}